import { Contacts } from './widgets';
import Icon24 from '@assets/icons/24.svg';

import './contactUs.scss';

export const ContactUs = () => {
  return (
    <div className='page-animation pt-8'>
      <div className='mx-auto my-0 w-full max-w-[1294px] px-5'>
        <div className='mb-5'>
          <div className='relative mx-2 text-xl font-bold text-[#f2f2f2] uppercase not-md:text-base'>
            <span className='absolute top-0 -left-3 font-semibold text-[#a73f33]'>/</span>
            Contact Us
          </div>
        </div>
        <div className='background-image flex h-[336px] flex-col items-center justify-center gap-4 rounded bg-[#1f1f1f] not-md:h-[273px]'>
          <Icon24 className='mx-auto mt-6 h-[68px] w-[67px] select-none' />
          <Contacts />
        </div>
      </div>
    </div>
  );
};
